import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_turnos/Administracion_turnos.html?vue&type=template&id=0bae90a1&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_turnos/Administracion_turnos.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_turnos/Administracion_turnos.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_turnos/Administracion_turnos.css?vue&type=style&index=0&id=0bae90a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae90a1",
  null
  
)

export default component.exports